import React from 'react';
import { Hero } from './components/Hero';
import { SoundFamiliar } from './components/SoundFamiliar';
import { CoreInsight } from './components/CoreInsight';
import { ProductReveal } from './components/ProductReveal';
import { WhatYouGet } from './components/WhatYouGet';
import { ToolkitPreview } from './components/ToolkitPreview';
import { Bonuses } from './components/Bonuses';
import { Benefits } from './components/Benefits';
import { HowItWorks } from './components/HowItWorks';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { PurchaseNotifications } from './components/PurchaseNotifications';
type AppProps = {
  showPurchaseNotifications?: boolean;
};
export function App({
  showPurchaseNotifications = true
}: AppProps) {
  return <div className="w-full overflow-x-hidden bg-ivory font-sans text-navy" data-id="element-0" data-mp="23utbk3a460as">
      <Hero data-id="element-1" data-mp="3iiwdijzxza14" />
      <main data-id="element-2" data-mp="3ij668fcdfvai">
        <SoundFamiliar data-id="element-3" data-mp="3ijpbowku4r7n" />
        <CoreInsight data-id="element-4" data-mp="3ii4qvyobommz" />
        <ProductReveal data-id="element-5" data-mp="3ml14tc2x3ukl" />
        <WhatYouGet data-id="element-6" data-mp="3mkho1yp07c85" />
        <ToolkitPreview data-id="element-7" data-mp="3mjzpgvevclx2" />
        <Bonuses data-id="element-8" data-mp="3mj6j3vjtnyfg" />
        <Benefits data-id="element-9" data-mp="3rcj8i7wbs999" />
        <HowItWorks data-id="element-10" data-mp="3rbzngibdp4r0" />
        <Offer data-id="element-11" data-mp="3rcsxpt9jqcdw" />
        <Guarantee data-id="element-12" data-mp="3rd189ei755lx" />
        <Testimonials data-id="element-13" data-mp="5yk6vxnnffx" />
        <Faq data-id="element-14" data-mp="6hovayao7c0" />
        <FinalCta data-id="element-15" data-mp="4wvhonpuufq" />
      </main>
      {showPurchaseNotifications ? <PurchaseNotifications data-id="element-16" data-mp="2zl3azit8d249" /> : null}
    </div>;
}